import { InboxOutlined } from '@ant-design/icons';
import { Modal, Typography, Upload } from 'antd';
import { useTranslation } from 'react-i18next';

const { Dragger } = Upload;
const { Paragraph, Text } = Typography;

interface BulkUploadModalProps {
  isOpen: boolean;
  onCancel: () => void;
}

function BulkUploadModal({ isOpen, onCancel }: BulkUploadModalProps) {
  const { t } = useTranslation();
  const i18nBase = 'scenes.stores.components.bulk_upload_modal';

  return (
    <Modal
      open={isOpen}
      title={t(`${i18nBase}.title`)}
      onCancel={onCancel}
      onOk={onCancel}
      okText={t(`${i18nBase}.buttons.close`)}
      cancelButtonProps={{ style: { display: 'none' } }}
      destroyOnClose
    >
      <Paragraph type="secondary">{t(`${i18nBase}.description`)}</Paragraph>
      <Dragger
        multiple={false}
        beforeUpload={() => false}
        accept=".csv,.xlsx"
        maxCount={1}
      >
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">{t(`${i18nBase}.drag_text`)}</p>
        <p className="ant-upload-hint">{t(`${i18nBase}.drag_hint`)}</p>
      </Dragger>
      <Text type="secondary" style={{ display: 'block', marginTop: 12 }}>
        {t(`${i18nBase}.coming_soon`)}
      </Text>
    </Modal>
  );
}

export default BulkUploadModal;
